var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cooperation-banner banner-box" }, [
      _c("div", { staticClass: "container banner-content" }, [
        _c("h3", [_vm._v("与合作伙伴建立共赢发展模式")]),
        _c("p", [_vm._v("\n            构建本地化移动互联平台\n        ")]),
        _c(
          "a",
          {
            staticClass: "title",
            attrs: {
              href: "https://www.xinminghui.com/saas-apply",
              target: "_blank"
            }
          },
          [_vm._v("立即合作")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-370cbfde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-370cbfde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/cooperation/banner/Index.vue
// module id = qKqv
// module chunks = 0